<template>
  <div class="w-100">
    <div class="recordsdiv">
      <b-row class="text-center">
        <b-col>
          <div class="form-group">
            <label for="exampleInputEmail1">Incident Type</label>
            <select
              v-model="incidentType"
              class="form-control"
              id="lawfirmList"
            >
              <option value="">All</option>
              <option
                v-for="ser in masterData.incidentTypes"
                v-bind:key="ser.id"
                v-bind:value="ser.slug"
              >
                {{ ser.title }}
              </option>
            </select>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label for="exampleInputEmail1">Suboffering Type</label>
            <select
              v-model="subofferingType"
              class="form-control"
              id="lawfirmList"
            >
              <option value="">All</option>
              <option
                v-for="ser in masterData.subofferingTypes"
                v-bind:key="ser.id"
                v-bind:value="ser.slug"
              >
                {{ ser.title }}
              </option>
            </select>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label for="exampleInputEmail1">Lawfirm</label>
            <select v-model="lawfirm" class="form-control" id="lawfirmList">
              <option value="">All</option>
              <option
                v-for="ser in masterData.lawfirms"
                v-bind:key="ser.id"
                v-bind:value="ser.slug"
              >
                {{ ser.title }}
              </option>
            </select>
          </div>
        </b-col>
        <b-col>
          <div class="form-group">
            <label for="">Client Name</label>
            <input
              class="form-control"
              placeholder="Search Client Name (Contains)"
              type="text"
              v-model="client"
            />
          </div>
        </b-col>
        <b-col class="text-left mt-2">
          <b-button class="btn btn-info mt-4" @click="fetchFilterResults"
            >Fetch Sows</b-button
          >
        </b-col>
      </b-row>
      <div v-if="sows.length > 0" class="row">
        <div
          class="
            col-sm-2
            ml-3
            d-inline-block
            sowcard
            p-0
            mb-3
            border-info
            card
            bg-white
            text-info
          "
          v-bind:key="sow.id"
          v-bind:slug="sow.slug"
          v-for="sow in sows"
        >
          <div class="lfcard p-1 text-nowrap card-body">
            <div>
              <h6 class="d-inline-block card-title font-weight-bold">
                {{ sow.clientName.substr(0, 22) }}
              </h6>
              <span
                class="badge font-weight-bold"
                v-b-popover.hover.top="sow.clientName"
                v-if="sow.clientName.length > 22"
                >...</span
              >
              <!-- <span class="float-right">
                <font-awesome-icon
                  title="Finalize"
                  :class="{
                    'text-success': sow.isFinalised,
                    'text-info': !sow.isFinalised,
                  }"
                  class="ml-2"
                  :icon="['fas', 'check']"
                  size="sm"
                  @click="!sow.isFinalised ? f(sow.clientName, sow.slug) : ''"
                />
              </span> -->
            </div>
            <div style="font-size: 11px">
              <div class="font-weight-bold">IncidentType:</div>
              <div>{{ sow.incidentTypeTitle }}</div>
              <div class="font-weight-bold">SubOfferingType:</div>
              <div>{{ sow.subofferingTypeTitle }}</div>
            </div>
            <div>
              <span
                class="py-1 px-1 d-inline card mr-1"
                style="font-size: 12px"
              >
                <a
                  :href="sow.sowFileInfo.webURl"
                  target="_blank"
                  class="card-link"
                >
                  <font-awesome-icon
                    class="mx-1 text-info"
                    :icon="['fas', 'file-word']"
                    size="lg"
                  />SoW
                </a>
                <font-awesome-icon
                  class="mx-1"
                  :icon="['fas', 'download']"
                  @click="downloadSow(sow.sowFileInfo)"
                  size="sm"
                />
              </span>
              <span
                class="py-1 px-1 d-inline card mr-1"
                v-if="sow.msaFileInfo"
                style="font-size: 12px"
              >
                <a
                  :href="sow.msaFileInfo.webURl"
                  target="_blank"
                  class="card-link"
                >
                  <font-awesome-icon
                    class="mx-1 text-info"
                    :icon="['fas', 'file-word']"
                    size="lg"
                  />MSA
                </a>
                <font-awesome-icon
                  class="ml-2"
                  :icon="['fas', 'download']"
                  @click="downloadMSA(sow.msaFileInfo)"
                  size="sm"
                />
              </span>
              <div class="d-inline ml-2 float-right">
                <span
                  :title="
                    sow.incidentType == 'it-mdr'
                      ? 'Create Renewal Contract'
                      : 'Create Amendment'
                  "
                >
                  <font-awesome-icon
                    v-if="!sow.isFinalised"
                    class="ml-2"
                    :icon="['fas', 'plus-circle']"
                    size="sm"
                    @click="a(sow.clientName, sow.slug, sow.incidentType)"
                  />
                </span>
                <span
                  :title="
                    sow.incidentType == 'it-mdr'
                      ? 'View Renewal Contract'
                      : 'View Amendment'
                  "
                >
                  <router-link
                    :to="{ name: 'amendments', params: { slug: sow.slug } }"
                    class="text-info"
                  >
                    <font-awesome-icon
                      v-if="!sow.isFinalised"
                      class="ml-2"
                      :icon="['fas', 'eye']"
                      size="sm"
                    />
                  </router-link>
                </span>
                <font-awesome-icon
                  v-if="!sow.isFinalised"
                  title="Create Again"
                  class="ml-2"
                  :icon="['fas', 'sync-alt']"
                  size="sm"
                  @click="r(sow.clientName, sow.slug)"
                />
              </div>
            </div>
          </div>
          <div class="p-2 card-footer text-muted">
            <small>
              Created On {{ sow.createdAt | formatDateTime }}
              <br />
              By {{ sow.createdBy ? sow.createdBy.name : "" }}
            </small>
          </div>
        </div>
      </div>
      <div
        v-if="sows.length === 0 && isfetched"
        class="w-100 mx-0 my-2 px-2 d-block alert alert-primary"
        role="alert"
      >
        No SoWs generated for the selected filters
      </div>
      <font-awesome-icon
        title="Create New Sow"
        class="text-info addSow ml-2"
        :icon="['fas', 'plus-circle']"
        size="5x"
        @click="c()"
      />
      <b-modal id="bv-modal-example" hide-footer>
        <template v-slot:modal-title>Are you sure?</template>
        <div class="d-block text-center">
          <h4>{{ modalTitle }}</h4>
        </div>
        <div class="d-flex justify-content-center">
          <b-button class="mt-3 mr-1 btn-secondary" @click="no()">No</b-button>
          <b-button class="mt-3 mr-1 btn-info" @click="yes()">Yes</b-button>
        </div>
      </b-modal>
    </div>
    <b-pagination
      v-if="rows > 0"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="pagination.recordsPerPage"
      aria-controls="my-table"
      align="center"
      style="margin-right: 17px"
      @input="fetchResults(currentPage)"
    ></b-pagination>
  </div>
</template>
<script>
import serviceProxy from "../services/index";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import moment from "moment";
export default {
  components: { Multiselect },
  name: "ViewSoWs",
  props: ["showForm"],
  beforeMount() {
    var that = this;
    that.$root.$emit("nostage");
    this.type = this.$store.getters.selectedBusinessType;
    // if (this.type) {
    //   this.handleSelect(this.type);
    // } else {
    //   this.type = "IR";
    //   this.handleSelect("IR");
    // }
    // if (this.$route.params.lawfirm) {
    //   this.lawfirm = this.$route.params.lawfirm;
    // }
  },
  created() {
    let that = this;
    let mrdata = that.$store.getters.masterData;
    this.masterData = mrdata;
    this.getMasterData();
    this.getSows(this.pagination);
  },
  methods: {
    goback: function (oEvent) {
      this.$router.go(-1);
    },
    getClients(searchText) {
      if (searchText.length > 2) {
        this.isLoading = true;
        serviceProxy.projects
          .getClients(this.$store.getters.token, searchText)
          .then((response) => {
            this.isLoading = false;
            this.clients = response.data.data;
          });
      }
    },
    getMasterData() {
      let that = this;
      serviceProxy.master
        .getMasterData(this.$store.getters.token)
        .then((data) => {
          let mrdata = data.data.data;
          console.log(mrdata);
          let services = _.filter(mrdata.services, (mr) => mr.isActive);
          let lawfirms = _.filter(mrdata.lawfirms, (mr) => mr.isActive);
          let incidentTypes = _.filter(
            mrdata.incidentTypes,
            (mr) => mr.isActive
          );
          let documents = _.filter(mrdata.documentTypes, (mr) => mr.isActive);
          let countries = _.filter(mrdata.countries, (mr) => mr.isActive);
          let authorities = _.filter(mrdata.authorities, (mr) => mr.isActive);
          let subofferingTypes = mrdata.subofferingTypes;
          that.masterData.subofferingTypes = _.clone(subofferingTypes);
          that.masterData.countries = _.clone(countries);
          that.masterData.documentType = _.clone(documents);
          let masterData = {
            services,
            lawfirms,
            incidentTypes,
            documents,
            countries,
            subofferingTypes,
            authorities,
          };
          that.$store.commit("populateMR", masterData);
        })
        .catch((e) => {
          //console.log(e);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "OOPS",
            message: "Error in fetching the data",
          });
        });
    },
    // handleSelect: function (val) {
    //   var that = this;
    //   that.sows = [];
    //   let mrdata = that.$store.getters.masterData;
    //   that.Types = mrdata.businesstype;
    //   if (
    //     !that.$store.getters.hasMasterData ||
    //     that.$store.getters.amendmentMode
    //   ) {
    //     that.$root.$emit("progress");
    //     that.$root.$emit("toast", {
    //       title: "Fetching Master Data",
    //       message: "Fetching the lawfirm data",
    //     });
    //     serviceProxy.master
    //       .getData(
    //         this.$store.getters.token,
    //         "lawfirm,service,incidenttype,country,documenttype"
    //       )
    //       .then((data) => {
    //         let mrdata = data.data;
    //         let services = _.filter(mrdata, (mr) => mr.type === "service");
    //         let lawfirms = _.filter(mrdata, (mr) => mr.type === "lawfirm");
    //         let incidentTypes = _.filter(
    //           mrdata,
    //           (mr) => mr.type === "incidenttype"
    //         );
    //         let country = _.filter(mrdata, (mr) => mr.type === "country");
    //         let documents = _.filter(
    //           mrdata,
    //           (mr) => mr.type === "documenttype"
    //         );
    //         that.lawfirm = that.$store.getters.selectedLawfirm;
    //         if (!that.lawfirm) {
    //           that.lawfirm = lawfirms[lawfirms.length - 2].Slug;
    //           that.lawfirmtitle = lawfirms[lawfirms.length - 2].Title;
    //         }
    //         //let carriers = _.filter(mrdata, mr => mr.type === "carrier");
    //         let masterData = (that.masterData = {
    //           services,
    //           lawfirms,
    //           incidentTypes,
    //           documents,
    //           country,
    //           //carriers
    //         });
    //         that.$store.commit("populateMR", masterData);
    //         //that.$root.$emit("done");
    //         that.getSows(val);
    //         that.$root.$emit("toast", {
    //           title: "Data Fetched",
    //           message: "Fetched the lawfirms",
    //         });
    //       })
    //       .catch((e) => {
    //         //console.log(e);
    //         that.$root.$emit("done");
    //         that.$root.$emit("toast", {
    //           title: "OOPS",
    //           message: "Error in fetching the data",
    //         });
    //       });
    //   } else {
    //     let mrdata = that.$store.getters.masterData;
    //     that.lawfirm = that.$store.getters.selectedLawfirm;
    //     if (!that.lawfirm) {
    //       that.lawfirm = mrdata.lawfirms[mrdata.lawfirms.length - 2].Slug;
    //     }
    //     that.masterData = mrdata;
    //     that.getSows(val);
    //   }
    // },
    fetchResults(currentPage) {
      let that = this;
      let pagination = that.pagination;
      pagination.startPageNo = currentPage;
      window.scrollTo(0, 0);
      that.getSows(pagination);
    },
    fetchFilterResults() {
      let that = this;
      let pagination = that.pagination;
      pagination.filters.incidentType = that.incidentType;
      pagination.filters.subofferingType = that.subofferingType;
      pagination.filters.lawfirm = that.lawfirm;
      pagination.filters.name = that.client;
      window.scrollTo(0, 0);
      that.getSows(pagination);
    },
    getSows(pagination) {
      var that = this;
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Fetching SoWs",
        message: "Fetching SoWs",
      });
      that.sows = [];
      that.rows = [];
      that.isfetched = false;
      serviceProxy.sow
        .getSows(this.$store.getters.token, pagination)
        .then((data) => {
          let sowsData = data.data.data;
          that.sows = sowsData.pageResult;
          this.rows = sowsData.totalRecords;
          that.isfetched = true;
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "SoWs Fetched",
            message: "Fetched the SoWs",
          });
        })
        .catch((e) => {
          //console.log(e);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "OOPS",
            message: "Error in fetching the SoWs",
          });
        });
    },
    gonext: function (oEvent) {
      this.$store.commit("settings", {
        services: this.services,
        //carrier: this.carrier,
        lawfirm: this.lawfirm,
      });
      this.$router.push({ path: "fill-placeholders" });
    },
    templateselected: function (oEvent) {},
    f(clientName, slug) {
      this.cursow = slug;
      this.modalTitle =
        "Are you sure you want to finalize the SoW for - " + clientName;
      this.curaction = "f";
      this.$bvModal.show("bv-modal-example");
    },
    c() {
      this.$root.$emit("init");
      this.$router.push({
        path: "choose-document",
        //  params: { lawfirm: this.lawfirm }
      });
    },
    downloadSow(fileInfo) {
      let that = this;
      let FileId = fileInfo.fileId;
      let FileName = fileInfo.fileName;
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Downloading",
        message: "Downloading SoW",
      });
      serviceProxy.sow
        .download(this.$store.getters.token, FileId, FileName)
        .then((data) => {
          var fileURL = window.URL.createObjectURL(
            new Blob([data.data], { type: "application/octet-stream" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", FileName, FileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: " Document download",
            message: " SOW downloaded",
          });
        })
        .catch((er) => {
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "Oops",
            message: "Error in downloading the SoW",
          });
          that.cursow = "";
        });
    },
    downloadMSA(fileInfo) {
      let that = this;
      let FileId = fileInfo.fileId;
      let FileName = fileInfo.fileName;
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Downloading",
        message: "Downloading MSA",
      });
      serviceProxy.sow
        .downloadMSA(this.$store.getters.token, FileId, FileName)
        .then((data) => {
          var fileURL = window.URL.createObjectURL(
            new Blob([data.data], { type: "application/octet-stream" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", FileName, FileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: " Document download",
            message: " MSA downloaded",
          });
        })
        .catch((er) => {
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "Oops",
            message: "Error in downloading the MSA",
          });
          that.cursow = "";
        });
    },
    handleDownload: function (filename, fileid) {
      let that = this;
      let FileId = fileid;
      let FileName = filename;
      that.$root.$emit("progress");
      that.$root.$emit("toast", {
        title: "Downloading  document",
        message: "Downloading  document ",
      });
      serviceProxy.nda
        .DownloadTemplate(this.$store.getters.token, FileId)
        .then((data) => {
          var fileURL = window.URL.createObjectURL(
            new Blob([data.data], { type: "application/octet-stream" })
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", FileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: " Document download",
            message: " Document downloaded",
          });
        })
        .catch((e) => {
          that.$root.$emit("done");
          that.$root.$emit("toast", {
            title: "OOPS",
            message: "Error downloading",
          });
        });
    },
    r(clientName, slug) {
      this.cursow = slug;
      this.modalTitle =
        "Are you sure you want to regnerate the SoW for - " + clientName;
      this.curaction = "r"; //f-finalize, t-trash, r-redo, d-download
      this.$bvModal.show("bv-modal-example");
    },
    a(clientName, slug, incidentType) {
      this.cursow = slug;
      this.modalTitle =
        "Are you sure you want to generate the " +
        (incidentType == "it-mdr" ? "renewal contract" : "Amendment") +
        " for - " +
        clientName;
      this.curaction = "a"; //f-finalize, t-trash, r-redo, d-download
      this.$bvModal.show("bv-modal-example");
    },
    t(clientName, slug) {
      this.cursow = slug;
      this.modalTitle =
        "Are you sure you want to delete the SoW for - " + clientName;
      this.curaction = "t"; //f-finalize, t-trash, r-redo, d-download
      this.$bvModal.show("bv-modal-example");
    },
    no() {
      this.cursow = "";
      this.modalTitle = "";
      this.curaction = "";
      this.$bvModal.hide("bv-modal-example");
    },
    yes() {
      //f-finalize, t-trash, r-redo, d-download
      switch (this.curaction) {
        case "r":
          this.$bvModal.hide("bv-modal-example");
          this.modalTitle = "";
          this.curaction = "";
          let sow = _.find(this.sows, (sow) => sow.slug === this.cursow);
          if (sow) {
            //Old Sow dosen't have Country
            sow.data.state.masterData.lawfirms =
              this.$store.getters.masterData.lawfirms;
            sow.data.state.masterData.countries =
              this.$store.getters.masterData.countries;
            sow.data.state.masterData.documents =
              this.$store.getters.masterData.documents;
            sow.data.state.masterData.authorities =
              this.$store.getters.masterData.authorities;
            sow.data.state.masterData.incidentTypes =
              this.$store.getters.masterData.incidentTypes;
            this.$store.commit("initSoW", sow.data.state);
            this.$router.push({
              path: "select-template",
              //  params: { lawfirm: this.lawfirm }
            });
          }
          break;
        case "a":
          this.$bvModal.hide("bv-modal-example");
          this.modalTitle = "";
          this.curaction = "";
          let amendmentsow = _.find(
            this.sows,
            (sow) => sow.slug === this.cursow
          );
          if (amendmentsow) {
            //Old Sow dosen't have Country
            amendmentsow.data.state.masterData.lawfirms =
              this.$store.getters.masterData.lawfirms;
            amendmentsow.data.state.masterData.countries =
              this.$store.getters.masterData.countries;
            amendmentsow.data.state.masterData.documents =
              this.$store.getters.masterData.documents;
            amendmentsow.data.state.masterData.subofferingTypes =
              this.$store.getters.masterData.subofferingTypes;
            amendmentsow.data.state.masterData.authorities =
              this.$store.getters.masterData.authorities;
            amendmentsow.data.state.masterData.incidentTypes =
              this.$store.getters.masterData.incidentTypes;
            let serviceslugs = [];
            let servicesss = [];
            _.each(
              amendmentsow.data.state.selectedServices,
              (selSer, index) => {
                selSer.isSelected = false;
                selSer.isOptional = false;
              }
            );
            _.each(
              this.$store.getters.masterData.services,
              function (item, index) {
                // if (
                //   !_.find(
                //     amendmentsow.data.state.masterData.services,
                //     (serv) => serv.slug === item.slug
                //   )
                // ) {
                servicesss.push(item);
                serviceslugs.push(item.slug);
                console.log(item);
                // }
              }
            );
            serviceProxy.template
              .getTemplate(
                this.$store.getters.token,
                amendmentsow.lawfirm,
                amendmentsow.subOfferingType
              )
              .then((response) => {
                this.templateConfig = response.data.data.masterServiceConfig;
                serviceProxy.serviceConfig
                  .getConfig(
                    this.$store.getters.token,
                    serviceslugs.join(","),
                    this.templateConfig
                  )
                  .then((data) => {
                    let servicesConfig = data.data.data;
                    for (
                      let index = 0;
                      index < servicesConfig.length;
                      index++
                    ) {
                      const element = servicesConfig[index];
                      const selService = _.find(servicesss, (ser) => {
                        return ser.slug === element.serviceId;
                      });
                      element.isOptional = selService.isOptional;
                      selService.serviceConfig = element;
                      selService.serviceConfig.additionalScopes = [];
                      //element.serviceTitle = element.isOptional ? `OPTIONAL - ${selService.Title}` : `${selService.Title}`;
                      let sConfig = this.$store.getters.servicesConfig;
                      amendmentsow.data.state.masterData.services = _.reject(
                        amendmentsow.data.state.masterData.services,
                        ["slug", selService.slug]
                      );
                      amendmentsow.data.state.servicesConfig = _.reject(
                        amendmentsow.data.state.servicesConfig,
                        ["serviceId", selService.slug]
                      );
                      sConfig = _.reject(sConfig, [
                        "serviceId",
                        selService.slug,
                      ]);
                      if (sConfig) {
                        sConfig.push(element);
                        this.$store.commit("servicesConfig", sConfig);
                      }
                      amendmentsow.data.state.masterData.services.push(
                        selService
                      );
                      amendmentsow.data.state.servicesConfig.push(element);
                    }
                  })
                  .catch((e) => {
                    console.log(e);
                    this.$root.$emit("done");
                  });
              })
              .catch((e) => {
                console.log(e);
                this.$root.$emit("done");
              });
            amendmentsow.data.state.IsAmendment = true;
            amendmentsow.data.state.SoWSlug = this.cursow;
            let amendmentsowPlaceholders = _.map(
              amendmentsow.data.placeHolders,
              (ph) => {
                return {
                  slug: ph.name === "sowdate" ? "msadate" : ph.name,
                  Value: ph.value,
                };
              }
            );
            let oldsowdate = _.filter(
              amendmentsowPlaceholders,
              (mr) => mr.slug === "msadate"
            );
            amendmentsow.data.state.placeholdervalues = _.clone(
              _.union(amendmentsow.data.state.placeholdervalues, oldsowdate)
            );
            this.$store.commit("initSoW", amendmentsow.data.state);
            this.$router.push({
              path: "select-template",
              //  params: { lawfirm: this.lawfirm }
            });
          }
          break;
        case "f":
          this.$bvModal.hide("bv-modal-example");
          this.modalTitle = "";
          this.curaction = "";
          var that = this;
          //this.cursow = "";
          that.$root.$emit("progress");
          that.$root.$emit("toast", {
            title: "Finalizing",
            message: "Finalizing the SoW",
          });
          serviceProxy.sow
            .finalize(this.$store.getters.token, this.cursow)
            .then((response) => {
              let sow = _.find(that.sows, (sow) => sow.slug === that.cursow);
              sow.IsFinalised = true;
              that.cursow = "";
              that.$root.$emit("done");
              that.$root.$emit("toast", {
                title: "Finalized",
                message: "Finalized the SoW",
              });
            })
            .catch((er) => {
              that.$root.$emit("done");
              that.$root.$emit("toast", {
                title: "Oops",
                message: "Error in finalizing the SoW",
              });
              that.cursow = "";
            });
          break;
        case "t":
          this.$bvModal.hide("bv-modal-example");
          this.modalTitle = "";
          this.curaction = "";
          var that = this;
          //this.cursow = "";
          that.$root.$emit("progress");
          that.$root.$emit("toast", {
            title: "Trashing",
            message: "Trashing the SoW",
          });
          serviceProxy.sow
            .trash(this.$store.getters.token, this.cursow)
            .then((response) => {
              let sow = _.find(that.sows, (sow) => sow.slug === that.cursow);
              sow.IsActive = false;
              that.cursow = "";
              that.$root.$emit("done");
              that.$root.$emit("toast", {
                title: "Trashed",
                message: "Trashed the SoW",
              });
            })
            .catch((er) => {
              that.$root.$emit("done");
              that.$root.$emit("toast", {
                title: "Oops",
                message: "Error in trashing the SoW",
              });
              that.cursow = "";
            });
          break;
        default:
          this.$bvModal.hide("bv-modal-example");
          this.modalTitle = "";
          this.curaction = "";
          this.cursow = "";
          break;
      }
    },
  },
  computed: {
    nextable() {
      return !(this.lawfirm && this.services.length > 0);
    },
    // activeSows() {
    //   return _.filter(this.sows, sow => sow.IsActive);
    // }
  },
  data() {
    return {
      pagination: {
        startPageNo: 1,
        recordsPerPage: 10,
        filters: {},
        sortOrder: {
          columnName: "CreatedAt",
        },
      },
      isfetched: false,
      masterData: {},
      lawfirm: "",
      clients: [],
      subofferingType: "",
      incidentType: "",
      lawfirmtitle: "",
      services: [],
      sows: [],
      mdrpostir: [],
      modalTitle: "",
      cursow: "",
      curaction: "",
      search: "",
      type: "",
      Types: [],
      filters: {},
      rows: {},
      pageResponse: [],
      currentPage: 1,
      client: "",
      isLoading: false,
      templateConfig: null,
      //carrier: ""
    };
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.activelf {
  border-top: 3px solid #17a2b8 !important;
  font-weight: bold;
}
.lfcard {
  border-top: 3px solid transparent;
  cursor: pointer;
}
.lawfirmcard {
  width: auto !important;
}
.sowcard {
  width: 265px;
}
.sowcard .card-footer {
  font-size: 14px;
}
.addSow {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
</style>
